// Iconos por agente: resolvemos CUALQUIER icono de lucide-react por su nombre,
// para que los cientos de agentes de las plantillas muestren su icono correcto.
import * as LucideIcons from "lucide-react";
import { Bot } from "lucide-react";

export const getIcon = (name) => LucideIcons[name] || Bot;

export const LEVEL_COLORS = {
  0: "#475569",
  1: "#10B981",
  2: "#84CC16",
  3: "#EAB308",
  4: "#F97316",
  5: "#EF4444",
};

export const LEVEL_LABELS = {
  0: "Solo Lectura",
  1: "Recomendar",
  2: "Preparar",
  3: "Ejecutar Bajo Riesgo",
  4: "Con Aprobación",
  5: "Prohibido",
};

export const RISK_COLORS = {
  low: "#10B981",
  medium: "#EAB308",
  high: "#F97316",
  critical: "#EF4444",
};

export const RISK_LABELS = {
  low: "Bajo",
  medium: "Medio",
  high: "Alto",
  critical: "Crítico",
};
